import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-91e2ac0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["xlink:href"]

import { computed } from 'vue'
import { isExternal } from '@/utils/validate'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    iconClass: {},
    className: {}
  },
  setup(__props: any) {

const props = __props

//是否是携带协议的图片链接
const isExt = computed(() => isExternal(props.iconClass || ''))
//拼接成symbolId在vite插件中指定了symbolI的格式 icon-图标名称
const iconName = computed(() => `#icon-${props.iconClass}`)

//添加类名 props.className外部传入自定义类名
const svgClass = computed(() =>
  props.className ? `svg-icon ${props.className}` : 'svg-icon'
)

//如果iconClass是自带协议的图标链接 则通过style css属性方式渲染
const styleExternalIcon = computed(() => ({
  mask: `url(${props.iconClass}) no-repeat 50% 50%`,
  '-webkit-mask': `url(${props.iconClass}) no-repeat 50% 50%`
}))

return (_ctx: any,_cache: any) => {
  return (isExt.value)
    ? (_openBlock(), _createElementBlock("div", _mergeProps({
        key: 0,
        style: styleExternalIcon.value,
        class: "svg-icon svg-external-icon"
      }, _ctx.$attrs), null, 16))
    : (_openBlock(), _createElementBlock("svg", _mergeProps({
        key: 1,
        class: svgClass.value,
        "aria-hidden": "true"
      }, _ctx.$attrs), [
        _createElementVNode("use", { "xlink:href": iconName.value }, null, 8, _hoisted_1)
      ], 16))
}
}

})